import styles from './styles.module.scss';

const SidebarList = ({ countText, children }) => {
  return (
    <div className={`${styles.sidebarList} custom-scroll`}>
      {countText && <div className={styles.sidebarListCount}>{countText}</div>}
      {children}
    </div>
  );
};

export default SidebarList;
